import Inbound from '../../../assets/inbound.svg';

const InboundIcon = (props: React.SVGProps<SVGSVGElement> & { rotation?: number; color: string }): JSX.Element => {
  const { rotation = 0 } = props;
  return <Inbound {...props} fill={props.color} transform={`rotate(${rotation})`} />;
};

export default InboundIcon;
